import { Component } from 'ng-metadata/core';
import './tray-loader.scss';

/**
 * @ngdoc directive
 * @name mwContentDocumentTrayLoader
 * @module mw.components.contentDocuments
 *
 * @description
 * `mw-content-document-tray-loader` is a component used to display a loading indicator while tray content is loaded.
 * @usage
 * <hljs hljs-language="html">
 *  <mw-content-document-tray-loader ng-if="$ctrl.isTrayLoading"></mw-content-document-tray-loader>
 * </hljs>
 */
@Component({
    selector: 'mw-content-document-tray-loader',
    template: `
        <div style="height:5px;width:100%;background-color: white;">
            <md-progress-linear md-mode="indeterminate"></md-progress-linear>
        </div>
    `
})
export class TrayLoaderComponent {}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/shared/tray-loader/tray-loader.component.ts